import { Router } from '@angular/router';
import { ApiService } from './../../../../api/api.service';
import { AppInjector } from './../../../../app-injector';
import { API_CALL_ERROR } from './../../../../store/action';
import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ALL_OFFERS_REQUESTED,
  FETCH_ALL_OFFERS_SUCCESSED,
  FETCH_OFFER_DETAIL_REQUESTED,
  FETCH_OFFER_DETAIL_SUCCESSED,
  GET_ALL_PRODUCTS_REQUESTED,
  GET_ALL_PRODUCTS_SUCCESSED,
  CREATE_OFFER_REQUESTED,
  CREATE_OFFER_SUCCESSED,
  UPDATE_OFFER_REQUESTED,
  UPDATE_OFFER_SUCCESSED
} from './offers-made.actions';
import * as _ from 'lodash';
import { FETCH_ALL_PRODUCTS_SUCCESSED, FETCH_ALL_PRODUCTS_REQUESTED } from '../edit.actions';

function* getOffers(action) {
  try {
    const results = yield AppInjector.get(ApiService)
      .offers.get(action.data.pagination, action.data.sorts, action.data.filters)
      .toPromise();
    if (results) {
      yield put({ type: FETCH_ALL_OFFERS_SUCCESSED, data: results });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllOffersRequest() {
  yield takeEvery(FETCH_ALL_OFFERS_REQUESTED, getOffers);
}

function* getOfferDetail(action) {
  try {
    const result = yield AppInjector.get(ApiService)
      .offers.getItemById(action.data)
      .toPromise();

    if (result) {
      yield put({ type: FETCH_OFFER_DETAIL_SUCCESSED, data: result });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchOfferDetailRequest() {
  yield takeEvery(FETCH_OFFER_DETAIL_REQUESTED, getOfferDetail);
}

function* getAllProduct(action) {
  try {
    const results = yield AppInjector.get(ApiService)
      .product.list()
      .toPromise();
    yield put({ type: GET_ALL_PRODUCTS_SUCCESSED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllProductRequest() {
  yield takeEvery(GET_ALL_PRODUCTS_REQUESTED, getAllProduct);
}

function* createOffer(action) {
  try {
    const result = yield AppInjector.get(ApiService)
      .offers.create(action.data)
      .toPromise();
    if (result) {
      yield put({ type: CREATE_OFFER_SUCCESSED, data: result });
      AppInjector.get(Router).navigate([`customer/edit/${action.data.user_id}/offers-made`]);
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateOfferRequest() {
  yield takeEvery(CREATE_OFFER_REQUESTED, createOffer);
}

function* watchFetchOfferSuccess() {
  yield takeLatest(FETCH_OFFER_DETAIL_SUCCESSED, getAllProduct);
}

function* updateOffer(action) {
  try {
    const result = yield AppInjector.get(ApiService)
      .offers.update(action.data)
      .toPromise();
    if (result) {
      yield put({ type: UPDATE_OFFER_SUCCESSED, data: result });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateOfferRequest() {
  yield takeEvery(UPDATE_OFFER_REQUESTED, updateOffer);
}

export default [watchUpdateOfferRequest, watchFetchOfferSuccess, watchCreateOfferRequest, watchFetchAllOffersRequest, watchFetchOfferDetailRequest, watchFetchAllProductRequest];
